import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useEditMode } from '@/contexts/EditModeContext';

const BlogCard = ({ post }) => {
  const { isEditMode, sendEditMessage } = useEditMode();
  
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleEditClick = (e) => {
    if (isEditMode) {
      e.preventDefault();
      e.stopPropagation();
      sendEditMessage('blog_post', post.id, post);
    }
  };

  return (
    <Card 
      className={`group overflow-hidden hover:shadow-xl transition-all duration-300 relative ${isEditMode ? 'cursor-pointer' : ''}`} 
      onClick={handleEditClick}
      data-testid={`blog-card-${post.slug}`}
    >
      {isEditMode && (
        <div className="absolute inset-0 border-2 border-dashed border-transparent group-hover:border-blue-500 rounded-lg transition-all duration-200 pointer-events-none z-10">
          <div className="absolute -top-8 left-0 bg-blue-500 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Edit: {post.title}
          </div>
        </div>
      )}
      <div className="relative h-48 overflow-hidden">
        <img
          src={post.featured_image || 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=640'}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-muted-foreground">
            <Calendar className="w-3 h-3" />
            {formatDate(post.created_at)}
          </span>
        </div>
      </div>
      <CardContent className="p-6">
        <h3 className="text-xl font-heading font-bold mb-2 group-hover:text-primary transition-colors line-clamp-2">
          <Link to={isEditMode ? '#' : `/blog/${post.slug}`} onClick={isEditMode ? handleEditClick : undefined}>
            {post.title}
          </Link>
        </h3>
        <p className="text-muted-foreground text-sm mb-4 line-clamp-3">
          {post.excerpt}
        </p>
        <Link
          to={isEditMode ? '#' : `/blog/${post.slug}`}
          onClick={isEditMode ? handleEditClick : undefined}
          className="inline-flex items-center text-primary font-medium text-sm hover:gap-2 transition-all"
          data-testid={`blog-read-more-${post.slug}`}
        >
          Read More <ArrowRight className="w-4 h-4 ml-1" />
        </Link>
      </CardContent>
    </Card>
  );
};

export default BlogCard;
